module.exports = __webpack_public_path__ + "media/images/career_camp/2022/texts/give_your_career_sm-0d13f5133546aa953a8aac57b4447e33.svg";